/* Gregor Shopify compatibility fixes
   - Keeps product variant IDs enabled so /cart/add always receives items.
   - Restores quantity +/- buttons with event delegation.
   - Handles skip-cart product buttons directly and redirects to checkout.
*/
(function () {
  'use strict';

  function toNumber(value, fallback) {
    var number = parseFloat(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function getRootPath() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
    return '/';
  }

  function getCartAddUrl() {
    var url = (window.routes && window.routes.cart_add_url) || (getRootPath().replace(/\/$/, '') + '/cart/add');
    return url.replace(/\.js$/, '') + '.js';
  }

  function getCheckoutUrl() {
    return getRootPath().replace(/\/$/, '') + '/checkout';
  }

  function getQuantityInput(button) {
    if (!button) return null;
    var wrapper = button.closest('quantity-input, .quantity, .quantity-popover-container, .product-form__quantity');
    if (!wrapper) return null;
    return wrapper.querySelector('input.quantity__input, input[name="quantity"], input[type="number"]');
  }

  function clamp(value, min, max) {
    if (Number.isFinite(min)) value = Math.max(value, min);
    if (Number.isFinite(max)) value = Math.min(value, max);
    return value;
  }

  function ensureFormQuantity(form, qty) {
    if (!form) return;
    var formQuantity = form.querySelector('input[name="quantity"]:not(.quantity__input)');
    if (!formQuantity) {
      formQuantity = document.createElement('input');
      formQuantity.type = 'hidden';
      formQuantity.name = 'quantity';
      form.appendChild(formQuantity);
    }
    formQuantity.value = String(Math.max(1, toNumber(qty, 1)));
    formQuantity.disabled = false;
  }

  function syncFormQuantity(input) {
    if (!input) return;
    var formId = input.getAttribute('form');
    var form = formId ? document.getElementById(formId) : input.closest('form');
    if (!form) return;
    ensureFormQuantity(form, input.value);
  }

  function updateDisabledState(input) {
    var wrapper = input && input.closest('quantity-input, .quantity, .quantity-popover-container, .product-form__quantity');
    if (!wrapper) return;

    var value = toNumber(input.value, 1);
    var min = toNumber(input.getAttribute('min') || input.dataset.min, 1);
    var maxAttr = input.getAttribute('max') || input.dataset.max;
    var max = maxAttr ? toNumber(maxAttr, NaN) : NaN;

    var minus = wrapper.querySelector('button[name="minus"], .quantity__button--minus');
    var plus = wrapper.querySelector('button[name="plus"], .quantity__button--plus');

    if (minus) minus.disabled = value <= min;
    if (plus && Number.isFinite(max)) plus.disabled = value >= max;
  }

  function changeQuantity(input, direction) {
    if (!input) return;

    var step = toNumber(input.getAttribute('step'), 1);
    if (!step || step < 1) step = 1;

    var min = toNumber(input.getAttribute('min') || input.dataset.min, 1);
    var maxAttr = input.getAttribute('max') || input.dataset.max;
    var max = maxAttr ? toNumber(maxAttr, NaN) : NaN;
    var current = toNumber(input.value, min || 1);
    var next = direction === 'minus' ? current - step : current + step;
    next = clamp(next, min, max);

    input.value = String(next);
    input.setAttribute('value', String(next));
    syncFormQuantity(input);
    updateDisabledState(input);

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function enableProductVariantIds(root) {
    root = root || document;
    root.querySelectorAll('form[action*="/cart/add"] input.product-variant-id[name="id"], product-form input.product-variant-id[name="id"], input.product-variant-id[name="id"]').forEach(function (input) {
      if (input.value) input.disabled = false;
    });
  }

  function syncAllQuantities(root) {
    root = root || document;
    root.querySelectorAll('input.quantity__input[name="quantity"], quantity-input input[name="quantity"]').forEach(function (input) {
      syncFormQuantity(input);
      updateDisabledState(input);
    });
  }

  function getExternalQuantityForForm(form) {
    if (!form || !form.id) return null;
    return document.querySelector('input.quantity__input[form="' + cssEscape(form.id) + '"]');
  }

  function prepareProductForm(form) {
    enableProductVariantIds(form);

    var externalQty = getExternalQuantityForForm(form);
    if (externalQty) {
      syncFormQuantity(externalQty);
      return;
    }

    var qty = form.querySelector('input[name="quantity"]');
    if (!qty) ensureFormQuantity(form, 1);
  }

  function setButtonLoading(form, isLoading) {
    var button = form && (form.querySelector('button[name="add"]') || document.querySelector('[form="' + cssEscape(form.id || '') + '"][name="add"]'));
    if (!button) return;
    button.disabled = !!isLoading;
    var spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function submitSkipCart(form) {
    prepareProductForm(form);

    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    var variantId = idInput && idInput.value;
    if (!variantId) return false;

    var data = new FormData(form);
    if (!data.get('quantity')) data.set('quantity', '1');

    setButtonLoading(form, true);

    fetch(getCartAddUrl(), {
      method: 'POST',
      body: data,
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (json) {
            throw new Error(json.description || json.message || 'No se pudo agregar el producto.');
          });
        }
        window.location.href = getCheckoutUrl();
      })
      .catch(function () {
        setButtonLoading(form, false);
        // Fallback sin JavaScript del tema: usa permalink de carrito para no volver a /cart/add sin items.
        var qty = data.get('quantity') || '1';
        window.location.href = getRootPath().replace(/\/$/, '') + '/cart/' + encodeURIComponent(variantId) + ':' + encodeURIComponent(qty) + '?checkout';
      });

    return true;
  }

  var clickValueBefore = new WeakMap();

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button[name="plus"], button[name="minus"], .quantity__button--plus, .quantity__button--minus');
    if (!button) return;
    var input = getQuantityInput(button);
    if (!input) return;
    clickValueBefore.set(button, input.value);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button[name="plus"], button[name="minus"], .quantity__button--plus, .quantity__button--minus');
    if (!button) return;
    var input = getQuantityInput(button);
    if (!input) return;

    var before = clickValueBefore.get(button);
    window.setTimeout(function () {
      var nativeChanged = String(input.value) !== String(before);
      if (!nativeChanged) {
        var direction = button.getAttribute('name') || (button.classList.contains('quantity__button--minus') ? 'minus' : 'plus');
        changeQuantity(input, direction === 'minus' ? 'minus' : 'plus');
      } else {
        syncFormQuantity(input);
        updateDisabledState(input);
      }
    }, 0);
  }, false);

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('input.quantity__input[name="quantity"], quantity-input input[name="quantity"]');
    if (!input) return;
    syncFormQuantity(input);
    updateDisabledState(input);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"], product-form form')) return;

    prepareProductForm(form);

    var skipInput = form.querySelector('input.product-variant-id[data-skip-cart="true"], input[name="id"][data-skip-cart="true"]');
    if (skipInput) {
      event.preventDefault();
      event.stopImmediatePropagation();
      submitSkipCart(form);
    }
  }, true);

  // Some buttons are outside the form and use form="product-form-id".
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button[name="add"][form], .main-product-atc[form]');
    if (!button || !button.getAttribute('form')) return;
    var form = document.getElementById(button.getAttribute('form'));
    if (!form) return;
    prepareProductForm(form);
  }, true);

  function boot(root) {
    enableProductVariantIds(root || document);
    syncAllQuantities(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
})();
